import { Controller } from "@hotwired/stimulus"

import { ExtensionClient } from "../extension/client"
import type { Browser } from "../extension/client.types"

// Points the link at the extension store page for the visitor's browser and
// swaps the label to match (labels come localized from the view). Both stay
// on their server-rendered Chrome defaults when the browser is unsupported.
export default class extends Controller<HTMLAnchorElement> {
  static values = { labels: Object }
  static targets = ["label"]

  declare readonly labelsValue: Partial<Record<Browser, string>>
  declare readonly labelTarget: HTMLElement

  connect() {
    const url = ExtensionClient.storeUrl
    if (url) this.element.href = url

    const browser = ExtensionClient.browser
    const label = browser && this.labelsValue[browser]
    if (label) this.labelTarget.textContent = label
  }
}
